import http from "../http-common";

class ProctorService {
  createProctor(data) {
    return http.post(`/api/proctor`, data);
  }
  getProctors() {
    return http.get(`/api/proctor`);
  }
  getProctor(id) {
    return http.get(`/api/proctor/` + id);
  }
  updateProctor(id, data) {
    return http.put(`/api/proctor/${id}`, data);
  }
}

export default new ProctorService();